import Vue from 'vue'
import Vuex from 'vuex'
import { api } from '@/api'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    month: ["Січень", "Лютий", "Березень", "Квітень", "Травень", "Червень", "Липень", "Серпень", "Вересень", "Жовтень", "Листопад", "Грудень"],
    services: [],
    user: null
  },
  getters: {
    isAdmin(state) {
      return Boolean(state.user && state.user.role == 0)
    }
  },
  mutations: {
    setServices(state, { data }) {
      state.services = data
    },
    setWhoami(state, { data }) {
      state.user = data
    }
  },
  actions: {
    async logout() {
      return await api({
        method: 'post',
        point: 'logout',
      })
    },

    async whoami({ commit, dispatch }) {
      await dispatch('getServices')

      const data = await api({
        point: 'whoami',
      })

      commit('setWhoami', { data })

      return data
    },

    async getAuth({ dispatch }, { e, p }) {
      const res = await api({
        method: 'post',
        point: 'login',
        data: {
          login: e,
          password: p
        }
      })
      dispatch('whoami')
      return res;
    },

    async getProcesses(_, more) {
      return await api({
        point: 'processes',
        ...more
      })
    },
    async editProcesses(_, { method = 'get', process, params, point = 'processes' }) {
      return await api({
        method,
        point,
        params,
        data: process
      })
    },
    async createProcesses(_, pr) {
      return await api({
        method: 'post',
        point: 'processes',
        data: pr
      })
    },
    async removeProcesses(_, { id }) {
      return await api({
        method: 'delete',
        point: `processes/${id}`
      })
    },


    async getServices({ commit }) {
      const data = await api({
        point: 'services'
      })
      commit('setServices', { data })
      return data
    },

    async getCards({ dispatch }, { params, url = 'cards' }) {
      await dispatch('getServices')
      return await api({
        point: url,
        params
      })
    },

    async submitCart(_, { number, name, phone, bonuses, comment, lang }) {
      return await api({
        method: 'post',
        point: 'cards',
        data: {
          id: number,
          name,
          phone,
          bonuses,
          comment,
          en: lang
        }
      })
    },
    async submitEditCart(_, { number, name, phone, bonuses, comment, lang, id }) {
      let data = {
        name,
        phone,
        bonuses,
        comment,
        en: lang
      }

      if (id != number) data.id = id

      return await api({
        method: 'post',
        point: `cards/${number}`,
        data
      })
    },

    async submitService(_, { name, price, id }) {
      return await api({
        method: 'post',
        point: `services${id ? `/${id}` : ''}`,
        data: {
          name,
          price
        }
      })
    },

    async addCost(_, { name, price, desc }) {
      return await api({
        method: 'post',
        point: 'costs',
        data: {
          name,
          price,
          desc
        }
      })
    },
    async getCosts(_, { date }) {
      return await api({
        point: 'costs',
        params: {
          date
        }
      })
    },


    async getAccounting(_, { date }) {
      return await api({
        point: 'accounting',
        params: {
          date
        }
      })
    },
    async addAccounting(_, { date }) {
      return await api({
        point: 'accounting',
        params: {
          date
        }
      })
    },


  }
})
